import { useQuery } from 'react-apollo';

import useSliceFilterOpts from '../../../../components/product/hooks/useSliceFilterOpts';
import { AccountRosterIdentities } from './graphql/queries';
import { ADDRESS_BOOK_CONTACT_TYPE_FILTER } from '../../views/AccountAddressBook/constants';

const useAccountAddressBook = ({
  limit = 100,
  albumFolderIds = [],
  albumIds = [],
  rosterIdentityListIds = [],
  contactLinkFilter = ADDRESS_BOOK_CONTACT_TYPE_FILTER.JOINED_ONLY,
}) => {
  const { filter, onFilterUpdate, onPageChange } = useSliceFilterOpts({
    initialFilter: {
      limit,
      searchQuery: '',
      cabinName: '',
      groupName: '',
    },
  });

  const {
    data: { me: user } = {},
    loading,
    error,
    refetch,
  } = useQuery(AccountRosterIdentities, {
    variables: {
      limit: filter.limit,
      offset: filter.offset,
      search_query: filter.searchQuery || undefined,
      cabin_name: filter.cabinName || undefined,
      group_name: filter.groupName || undefined,
      album_folder_ids:
        contactLinkFilter === ADDRESS_BOOK_CONTACT_TYPE_FILTER.CONTACTS_ONLY
          ? []
          : albumFolderIds,
      contact_link_album_folder_ids:
        contactLinkFilter === ADDRESS_BOOK_CONTACT_TYPE_FILTER.JOINED_ONLY
          ? []
          : albumFolderIds,
      album_ids:
        contactLinkFilter === ADDRESS_BOOK_CONTACT_TYPE_FILTER.CONTACTS_ONLY
          ? []
          : albumIds,
      contact_link_album_ids:
        contactLinkFilter === ADDRESS_BOOK_CONTACT_TYPE_FILTER.JOINED_ONLY
          ? []
          : albumIds,
      roster_identity_list_ids: rosterIdentityListIds,
    },
    fetchPolicy: 'cache-and-network',
  });

  const addressBook = user?.roster_identities.records ?? [];
  const addressBookTotal = user?.roster_identities.total ?? 0;

  const onAddressBookReset = () => {
    const resetVariables = {
      page: 0,
      offset: 0,
      searchQuery: '',
      cabinName: '',
      groupName: '',
    };
    onFilterUpdate(resetVariables);
    refetch({
      page: 0,
      offset: 0,
      searchQuery: '',
      cabinName: '',
      groupName: '',
    });
  };

  return {
    filter,
    onFilterUpdate,
    onPageChange,
    loading,
    error,
    addressBook,
    addressBookTotal,
    onAddressBookReset,
    hasSelectedTiers: user?.custom_print_tiers?.total > 0,
  };
};

export default useAccountAddressBook;
